import React from "react";
import { FLEET_IMAGES, RUBBLE_IMAGE, HERO_IMAGE } from "@/lib/site-data";

const ITEMS = [
  { src: HERO_IMAGE, label: "Branded fleet · Toronto" },
  { src: FLEET_IMAGES[1], label: "Quality You Can Trust" },
  { src: FLEET_IMAGES[2], label: "Bins on every job" },
  { src: RUBBLE_IMAGE, label: "On-site delivery" },
  { src: FLEET_IMAGES[0], label: "Clean swap-outs" },
];

export default function FleetStrip() {
  return (
    <section
      data-testid="fleet-strip-section"
      id="fleet"
      className="bg-white border-b-2 border-slate-200"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-8 py-16 lg:py-20">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">
          <div>
            <div className="text-[11px] font-extrabold tracking-[0.22em] uppercase text-sky-600">Our Fleet</div>
            <h2 className="font-display font-black text-2xl sm:text-3xl lg:text-4xl text-slate-900 mt-3 leading-tight">
              You call. We show up. Bin&apos;s in your driveway&nbsp;&mdash;&nbsp;usually the same day.
            </h2>
          </div>
          <div className="text-sm text-slate-600 max-w-sm">
            Branded Troya Mini Bins fleet, maintained trucks, polite drivers &mdash; the way bin rental should be done.
          </div>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 lg:gap-4">
          {ITEMS.map((it, idx) => (
            <figure
              key={idx}
              className={`group relative overflow-hidden border-2 border-slate-900 bg-slate-100 ${
                idx === 0 ? "col-span-2 row-span-2 lg:col-span-2 lg:row-span-2" : ""
              }`}
            >
              <img
                src={it.src}
                alt={it.label}
                loading="lazy"
                className={`w-full ${
                  idx === 0 ? "h-72 lg:h-[440px]" : "h-44 lg:h-52"
                } object-cover group-hover:scale-105 transition-transform duration-500`}
              />
              <figcaption className="absolute bottom-0 left-0 right-0 bg-slate-900/85 backdrop-blur-sm px-3 py-2 text-[10px] font-bold tracking-[0.18em] uppercase text-white">
                <span className="inline-block h-1.5 w-1.5 bg-sky-400 mr-2 align-middle" />
                {it.label}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
